"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdvDate_1 = require("./lib/AdvDate");
var PreservationTable_1 = require("./modules/PreservationTable");
var EngineResults = (function () {
    function EngineResults(engineOutput, params) {
        this.engineResults = engineOutput;
        this.parameters = params.clone();
        this.runOutAge = engineOutput.subjectOutput.runOutAge;
        this.preservationAge = this.getPreservationAge(new AdvDate_1.AdvDate().plus(-1 * params.getParamNumber("AgeNow")));
        this.lifeExpectancy = this.getlifeExpectancy(params.getParamNumber("AgeNow"), params.getParamString("Sex"), params);
        this.deflatedCombinedBalanceAtRetirement = engineOutput.deflatedCombinedBalanceAtRetirement();
        this.deflatedCombinedIncomeAtRetirement = engineOutput.deflatedCombinedIncomeAtRetirement();
    }
    EngineResults.prototype.getPreservationAge = function (dateOfBirth) {
        return PreservationTable_1.PreservationTable.createDefault().preservationAge(dateOfBirth);
    };
    EngineResults.prototype.getlifeExpectancy = function (ageNow, sex, params) {
        var lifeTable = params.getParamObject("AbsLifeTable");
        var yearsLeft = Math.floor(lifeTable.lifeExpectancy(Math.max(ageNow, lifeTable.startAge), sex));
        return Math.max(ageNow, lifeTable.startAge) + yearsLeft;
    };
    return EngineResults;
}());
exports.EngineResults = EngineResults;
//# sourceMappingURL=EngineResults.js.map